import React from "react";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import { withNamespaces, WithNamespaces } from "react-i18next";
import Clear from "@material-ui/icons/Clear";
import { DialogProps } from "./dialogRouter";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import { RequiredParts, ConflictingPartErrorResponse } from './conflictingParts';
import { RemovePartPayload } from "../../services/http/real";
import store from '../../redux/store';
import removePartAsync from '../../redux/async-actions/removePart';
import FadeInLetters from "../shared/FadeInLetters";

const RemoveConflictingParts: React.FunctionComponent<DialogProps<ConflictingPartErrorResponse> & WithNamespaces> = ({ hideDialog, t, data, title }) => {
	const rulesResult = data.RulesResult;
	const removePart = () => {
		const payload: RemovePartPayload = {
			PartId: rulesResult.Part.Code,
			RemoveParts: rulesResult.Parts.map((part) => part.Code),
		}
		store.dispatch(removePartAsync(payload) as any);
	}

	return (
		<Dialog
			disableBackdropClick={true}
			fullWidth={true}
			maxWidth={"md"}
			open={true}
			onClose={hideDialog}
			aria-labelledby="conflicting-parts-modal"
			id="conflicting-parts-dialog"
		>
			<DialogTitle id="conflicting-parts-dialog-title">
				<Grid container justify="space-between" direction="row">
					<h2
						id="conflicting-parts-modal"
						className="conflicting-part-headline underline uppercase"
					>
						<FadeInLetters text={title} />
					</h2>
					<IconButton className="dialog-hide-icon" onClick={hideDialog}>
						<Clear />
					</IconButton>
				</Grid>
			</DialogTitle>
			<DialogContent>
				<RequiredParts rule={rulesResult} deleteRule={true} />
			</DialogContent>
			<DialogActions>
				<button onClick={hideDialog} className="secondary m-r-5">
					{t("buttons.cancel")}
				</button>
				<button onClick={removePart} className="primary m-r-5">
					{t("buttons.confirmPartRules")}
				</button>
			</DialogActions>
		</Dialog >
	)
}

export default withNamespaces()(RemoveConflictingParts);
